var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"sparrow-worker",attrs:{"id":"sparrowWorker","src":"https://sparrow-js.github.io/sparrow-worker/"},on:{"load":_vm.iframeOnload}})}
var staticRenderFns = []

export { render, staticRenderFns }